/* eslint-disable max-len */
angular.module('tgaAdmin').controller('GamesController', [
  '$scope',
  '$rootScope',
  '$state',
  '$window',
  '$filter',
  '$timeout',
  '$uibModal',
  'gameService',
  'modalService',
  'domainService',
  'statsService',
  'userService',
  'divisionService',
  'ngIntroService',
  'tagService',
  'settingsService',
  'supportService',
  'envService',
  function (
    $scope,
    $rootScope,
    $state,
    $window,
    $filter,
    $timeout,
    $uibModal,
    gameService,
    modalService,
    domainService,
    statsService,
    userService,
    divisionService,
    ngIntroService,
    tagService,
    settingsService,
    supportService,
    envService,
  ) {
    $scope.data = {
      alerts: [],
      divisions: [],
      tags: [],
      lastStep: $state.params.lastStep || false,
      gameTypes: gameService.getGameTypes(),
      isAdmin: userService.checkUserType(['admin', 'super_admin', 'sales_admin', 'support_admin']),
      isEditor: userService.checkUserType(['editor', 'creator_admin']),
      isSuperAdmin: userService.checkUserType(['super_admin']),
      isViewer: userService.checkUserType(['user', 'viewer_admin']),
      environment: envService.get(),
      countupOptions: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ':',
      },
      datePickerOptions: settingsService.getDatePickerOptions(
        {},
        {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day') ||
              !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.actions.loadChart();
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      ),
      chartOptions: {
        series: [
          {
            name: 'Sessions',
            data: [],
          },
          {
            name: 'Players',
            data: [],
          },
        ],
        chart: {
          height: 250,
          type: 'line',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          offsetY: 15,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 4,
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: 0,
          },
        },
        yaxis: [
          {
            seriesName: 'Sessions',
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB',
            },
            labels: {
              style: {
                colors: '#008FFB',
              },
            },
            title: {
              text: 'Sessions',
              style: {
                color: '#008FFB',
              },
            },
          },
          {
            seriesName: 'Players',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#00E396',
            },
            labels: {
              style: {
                colors: '#00E396',
              },
            },
            title: {
              text: 'Players',
              style: {
                color: '#00E396',
              },
            },
          },
        ],
      },
    };

    $scope.introOptions = {
      steps: [
        {
          intro:
            "Welcome to the new Training Arcade® dashboard. We have some new features to show you. Let's check them out!",
          position: 'bottom',
        },
        {
          element: '#aside [ui-sref="v1.games"]',
          intro:
            "The new menu format puts <em>Games</em> at the top of the list for easy access. After all, that's why we're here! 😀",
          position: 'right',
        },
        {
          element: '.chart-toggle',
          intro:
            'The new <em>Game Trends</em> chart helps you visualize key engagement data.<br />Click the arrow to toggle the chart. Go ahead...click it! 😏',
          position: 'left',
        },
        {
          element: '.main-chart > .box-body:last-child',
          intro:
            "These are the aggregate stats across all games in your account. We've added <em>Accuracy</em> as a new stat so you can see how your players are performing across all games.",
          position: 'bottom',
        },
        {
          element: '.game-details',
          intro:
            "Click the <em>Details</em> button to go to the game section where you'll access all the game-specific features like analytics, leaderboards, editing and more!",
          position: 'left',
        },
        {
          element: '#step3',
          intro: 'More features, more fun.',
          position: 'left',
        },
      ],
      showStepNumbers: false,
      showBullets: false,
      showProgress: true,
      scrollToElement: true,
      scrollPadding: 200,
      exitOnOverlayClick: false,
      exitOnEsc: false,
      nextLabel: 'Next',
      prevLabel: 'Previous',
      skipLabel: 'Exit',
      doneLabel: 'Done',
    };

    $scope.viewmodel = {
      showChart: false,
      range: 'Last 30 Days',
      oldRange: {
        startDate: moment().subtract(29, 'days').startOf('day'),
        endDate: moment().endOf('day'),
      },
      dateRange: {
        startDate: moment().subtract(29, 'days').startOf('day'),
        endDate: moment().endOf('day'),
      },
      games: [],
      canExport: true,
      showIsDemoColumn: ['tga', 'tga-qa'].some((d) => domainService.domain === d),
    };

    $scope.initialize = function () {
      $scope.loading = true;

      divisionService.getDivisions().then((divisions) => {
        $scope.data.divisions = divisions;
      });

      if (!$scope.data.isViewer) {
        tagService.getTags().then((tags) => {
          $scope.data.tags = tags;
        });
      }

      settingsService.getSettings().then((settings) => {
        $scope.data.datePickerOptions.ranges['All Time'] = [moment(settings.date_created).startOf('month'), moment()];
      });

      const agreementTypeSubscription = 1; // AGREEMENT_TYPE_SUBSCRIPTION
      supportService.getUserAgreements([agreementTypeSubscription], userService.getUserData().id).then((agreements) => {
        if (!agreements[0].date_agreed) {
          $scope.actions.termsAndConditionsModal(agreements);
        }
      });

      // DMT-992
      // Calling loadGames() without tableState passed in when initializing will cause the full list of games
      // to be loaded from the server. `loadGames` will be called again immediately with tableState, returning
      // the filters/paginated response.
      // $scope.actions.loadGames();

      $scope.actions.loadChart();
    };

    $scope.actions = {
      loadGames(tableState) {
        $scope.loading = true;

        const params = tableState
          ? {
            paginate: true,
            page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
            limit: tableState.pagination.number,
            sort: tableState.sort.predicate,
            order: tableState.sort.reverse ? 'desc' : 'asc',
          }
          : {};

        if (tableState?.search?.predicateObject) {
          Object.keys(tableState.search.predicateObject).forEach((key) => {
            // Check for divisions first and set values to a divisions array
            if (key === 'divisions') {
              params['divisions[]'] = Object.keys(tableState.search.predicateObject.divisions).map(
                (divisionKey) => tableState.search.predicateObject.divisions[divisionKey].value,
              );
            } else {
              params[key] = tableState.search.predicateObject[key];
            }
          });
        }

        gameService.getGames(params).then((response) => {
          $scope.loading = false;
          // Check for paginated response coming from `items` before falling back to the response
          $scope.viewmodel.games = response.items || response;

          if (tableState) {
            tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
            tableState.pagination.totalItemCount = response.total;
          }

          // Check for an empty predicateObject along with result length to determine
          // the empty result is due to a search filter or having no games
          if (
            !tableState.pagination.totalItemCount &&
            tableState.search.predicateObject && // fix null error
            Object.keys(tableState.search.predicateObject).length === 0 &&
            !$scope.data.isViewer
          ) {
            $scope.data.gameTypes = gameService.getGameTypes();

            for (let i = 0; i < $scope.data.gameTypes.length; i++) {
              if (!domainService.hasPermission('game', $scope.data.gameTypes[i].key)) {
                $scope.data.gameTypes[i].disabled = true;
              }
            }

            const defaults = {
              backdrop: true,
              keyboard: true,
              animation: true,
              templateUrl: 'templates/partials/game/game_selection_modal.html',
              size: null,
            };

            const options = {
              title: 'Welcome',
              message: 'Add your first game now. Which type of game do you want to create?',
              closeButton: 'Cancel',
              actionButton: false,
              gameTypes: $scope.data.gameTypes,
            };

            // Timeout hack so modal backdrop always shows
            $timeout(() => {
              modalService
                .showModal(options, defaults)
                .then((key) => {
                  const matchedType = $filter('filter')($scope.data.gameTypes, { key }, true);

                  if (matchedType.length && matchedType[0].disabled) {
                    $state.go('v1.account', {
                      type: key,
                      tab: 'subscriptions',
                    });
                  } else {
                    $state.go('v1.addGame', {
                      type: key,
                    });
                  }
                })
                .catch(angular.noop);
            }, 0);
          }

          // Intro
          if ($scope.viewmodel.games.length) {
            userService.getData('intro1').then((val) => {
              if (!val) {
                $timeout(() => {
                  ngIntroService.clear();
                  ngIntroService.setOptions($scope.introOptions);
                  const lastStep = $scope.introOptions.steps.length - 1;

                  if ($scope.data.lastStep) {
                    ngIntroService.start().goToStep(lastStep);
                  } else {
                    ngIntroService.start();
                  }

                  ngIntroService.onAfterChange(() => {
                    // eslint-disable-next-line no-underscore-dangle
                    const currentStep = ngIntroService.intro._currentStep;
                    if (currentStep === lastStep) {
                      ngIntroService.clear();
                      userService.setData('intro2', false);
                      $state.go('v1.analytics', { game_id: $scope.viewmodel.games[0].game_id });
                    }
                  });

                  ngIntroService.onExit(() => {
                    userService.setData('intro1', true);
                  });
                }, 500);
              }
            });
          }
        });
      },

      loadChart() {
        statsService
          .getGlobalGameStats(
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
          )
          .then((response) => {
            const avg_time = $filter('formatDuration')(response.average_time).split(':');
            response.average_time = parseFloat(`${avg_time[1]}.${avg_time[2]}`);
            response.average_accuracy *= 100;
            $scope.viewmodel.globalGameStats = response;
          });

        $scope.loadingChart = true;

        statsService
          .getOverviewChart(
            null,
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
          )
          .then((response) => {
            $scope.data.chartOptions.series = [
              {
                name: 'Sessions',
                data: response.sessions,
              },
              {
                name: 'Players',
                data: response.players,
              },
            ];

            $scope.data.chartOptions.xaxis.categories = response.xaxis;

            $scope.loadingChart = false;
          });
      },
      // eslint-disable-next-line consistent-return
      exportGameStats() {
        if (!$scope.viewmodel.games.length) {
          return false;
        }

        $scope.viewmodel.canExport = false;

        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-report.html',
            controller: 'ReportModalController',
            backdrop: true,
            resolve: {
              extras() {
                return {
                  report: {
                    report_type: 'games_report',
                    start_date: $scope.viewmodel.dateRange.startDate.toISOString(true),
                    end_date: $scope.viewmodel.dateRange.endDate.toISOString(true),
                  },
                };
              },
            },
          })
          .result.then((report_id) => {
            $scope.actions.watchReport(report_id);
          })
          .catch(() => {
            $scope.viewmodel.canExport = true;
          });
      },
      watchReport() {
        // empty function
      },
      toggleChart() {
        $scope.viewmodel.showChart = !$scope.viewmodel.showChart;
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      launch(game) {
        $window.open(gameService.getGameUrl(game), '_blank');
      },
      presentGame() {
        $rootScope.$emit('newGamePopup');
      },
      termsAndConditionsModal(agreements) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-terms-and-conditions.html',
            controller: 'TermsAndConditionsModalController',
            backdrop: 'static',
            backdropClass: 'modalBackdrop',
            windowClass: 'modalWindow',
            keyboard: false,
            resolve: {
              extras() {
                return {
                  agreement: agreements[0],
                };
              },
            },
          })
          .result.then(() => { })
          .catch(angular.noop);
      },
    };

    $scope.$on('$destroy', () => {
      ngIntroService.clear();
    });

    $scope.initialize();
  },
]);
